import Bluebird from 'bluebird';

import { navigationState } from '@trello/router';

export const getSpinner = () => {
  navigationState.setValue({
    isNavigating: true,
  });

  return Bluebird.resolve().disposer(function () {
    navigationState.setValue({
      isNavigating: false,
    });
  });
};
